import * as types from "../actions/actionTypes";
import { getAllDebitCategoriesResponse, getDebitCategoryByIdResponse } from "../actions";
import { createEntitySagas } from "./sagaHelpers";

export const debitCategoryEntity = createEntitySagas({
  entity: "debitcategory",
  endpoint: "debit-categories",
  label: "Debit category",
  scope: "none",
  requiredParam: "manufacturerId",
  selectSlice: (state) => state.debitcategory,
  listKey: "categories",
  types: {
    getAll: types.GET_ALL_DEBIT_CATEGORIES,
    getById: types.GET_DEBIT_CATEGORY_BY_ID,
    create: types.CREATE_DEBIT_CATEGORY,
    update: types.UPDATE_DEBIT_CATEGORY,
    remove: types.DELETE_DEBIT_CATEGORY,
  },
  actions: { getAllResponse: getAllDebitCategoriesResponse, getByIdResponse: getDebitCategoryByIdResponse },
});

export const debitcategorySaga = debitCategoryEntity.watcher;
